<template>

  <div id="h-s">


    <div class="first-part">
      <div class="h-s-big-wrapper">
        <img src="@/assets/h-s/pipe.png" class="pipe-top-left"/>
      </div>
      <div class="h-s-wrapper">
        <img src="@/assets/h-s/safety-button.png" class="pipe-top-right"/>
        <div class="motoroil-group-first-part">

          <div class="general-container">
            <div class="row pt-5">
              <div class="col-12">
                <h2 class="text-red text-literata">
                  H&S
                </h2>
                <h5 class="text-white mb-2 mt-4">Safe & Sound</h5>

                <video-screen :key="selectedVideo" :video-url="getVideo"></video-screen>
                <div class="seats"  style="height:100px;z-index:1;position:relative;">
                  <img src="@/assets/images/seats.png" style="height:80px;"/>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tv-floor">

      </div>
    </div>

    <div class="second-part">
      <div class="h-s-wrapper">

        <div class="content">
          <div class=" mb-5 pt-5">

            <b-button variant="red" class=" mr-3" :class="selectedVideo === 0 ? 'cta-button' : 'cta-button-inactive'" @click="selectedVideo = 0" >Safety Day</b-button>
            <b-button variant="red" class=" mr-3" :class="selectedVideo === 1 ? 'cta-button' : 'cta-button-inactive'" @click="selectedVideo = 1">9-life Saving Rules</b-button>
            <b-button variant="red" :class="selectedVideo === 2 ? 'cta-button' : 'cta-button-inactive'" @click="selectedVideo = 2;">Driver Awareness</b-button>

          </div>

          <div class="pt-5">
            <h3 class="inner-content-title text-zonapro text-left text-white mb-4">
              Health & Safety
            </h3>
            <div class="content">
              <p>Tο τμήμα ΟΕ &amp; QHSSE – Operational Excellence &amp; Quality Health Safety Security Environment - εργάζεται με βάση τις αρχές συνεχούς βελτίωσης (Plan, Do, Check, Improve) λειτουργιών όλων των εμπορικών εταιρειών Πετρελαιοειδών και Αερίων του Ομίλου ΜΟΗ σε όλες τις χώρες δραστηριοποίησης τους.&nbsp;&nbsp;</p><p>Διαθέτει εξειδικευμένους και έμπειρους σύμβουλους και ελεγκτές των λειτουργιών Παραλαβών, Εμπορίας (Πρατήρια ή Επιχειρήσεων), Αποθήκευσης και Διανομής, Μεταφορών, Γραφείων και Ποσοτικού/Ποιοτικού Ελέγχου.&nbsp;</p><p>Στόχος του είναι τα Μηδέν Συμβάντα που μπορεί να έχουν αντίκτυπο σε Ανθρώπους, Περιβάλλον, Κοινωνία, Περιουσίας, καθώς και η διατήρηση του υψηλού επιπέδου υπηρεσιών σε πελάτες και η πρόσδοση αξίας στους Μετόχους, τις Αρχές και άλλα Ενδιαφερόμενα Μέρη υπό το πρίσμα της βιωσιμότητας και της αειφορίας.&nbsp;&nbsp;</p><p>Στις αρμοδιότητες του, μεταξύ άλλων, εμπίπτουν:&nbsp; </p><ul><li>Σχεδιασμός και Προγραμματισμός Δράσεων με αντικείμενο την Ποιοτική Διαχείριση, Υγεία, Ασφάλεια, Φύλαξη και Περιβάλλον (Q-H-S-S-Ε)</li><li>Υποστήριξη των Διευθύνσεων στην υλοποίηση τους</li><li>Εξασφάλιση και Συμμόρφωση</li><li>Αναθεώρηση και Βελτίωση&nbsp;</li></ul><p>Το τμήμα αναφέρεται στον εκτελεστικό αντιπρόεδρο του Ομίλου ΜΟΗ και στους Γενικούς Διευθυντές των εν λόγω εμπορικών εταιρειών.&nbsp;<br></p>

            </div>
           </div>


        </div>

        <img src="@/assets/h-s/safety-symbol.png" class="symbol animate__animated animate__fadeInRight"/>
        <img src="@/assets/h-s/safety-pharm-box.png" class="pharm-box animate__animated animate__fadeInTopLeft"/>
        <img src="@/assets/h-s/safety-woman.png" class="woman-right"/>
        <img src="@/assets/h-s/safety-woman2.png" class="woman-left"/>

        <div class="row next-section-wrapper ">
          <div class="col-12 col-md-6 text-right">

            <prev-section-btn text="Go Digital" to-url="go-digital"></prev-section-btn>
          </div>
          <div class="col-12 col-md-6 text-left">

            <div class="next-section">

              <next-section-btn text="Basic Policies" to-url="basic-policies"></next-section-btn>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>

<style lang="scss">
#h-s{
  position:relative;
  background: radial-gradient(#475580 -30%, #170F20 55%);

  .h-s-big-wrapper{
    max-width:1920px;
    margin:0 auto;
    position:relative;
  }
  .h-s-wrapper{
    position:relative;
    max-width:1440px;
    margin:0 auto;
  }
  .second-part, .first-part{
    position:relative;
  }

  .content{
    max-width:650px;
    margin: 0 auto;
    p{
      text-align:justify;
      font-size:0.9rem;
      color:white;
    }
  }
  .pipe-top-left{
    position:absolute;
    top:0;
    left:0;
    width:35%;
  }
  .pipe-top-right{
    position:absolute;
    top:0;
    right:17%;
    width:85px;

  }

  h2{
    font-family: "ZonaPro", sans-serif;
    font-weight:bold!important;
  }

  .screen, .screen img{
    height:500px;
    @media(min-width:1920px) {
      height: 500px;
    }
  }
  .woman-right{
    position:absolute;
    right: 15%;
    bottom:0;
    width:160px;
  }

  .woman-left{
    position:absolute;
    bottom:0;
    width:130px;
    left:15%;

  }

  .pharm-box{

    position:absolute;
    top:12%;
    left:12%;
    width:85px;
  }
  .symbol{
    position:absolute;
    top:20%;
    right:15%;
    width:60px;
  }

  .next-section-wrapper{
    padding: 5rem 0;
  }

  .tv-floor{
    z-index:0;
    top:650px;
    position:absolute;
    height:40px;
    width:100%;

    background: radial-gradient(40.82% 349.08% at 50.2% 44.72%, #475580 2%, #342B4A 53%, #170F20 100%);
  }

}
</style>
<script>

import NextSectionBtn from "../components/NextSectionBtn";
import PrevSectionBtn from "../components/PrevSectionBtn";
import VideoScreen from "../components/VideoScreen";

export default{
  components:{VideoScreen, NextSectionBtn, PrevSectionBtn},


  data(){
    return{
      selectedVideo: 0,
      videos: ['https://edlservices.s3.eu-north-1.amazonaws.com/office-safety-101.mp4',
        'https://edlservices.s3.eu-north-1.amazonaws.com/life-savings.mp4',
        'https://edlservices.s3.eu-north-1.amazonaws.com/driving-video.mp4']
    }
  },

  computed:{
    getVideo(){

      return this.videos[this.selectedVideo]
    }
  },

  mounted(){
    this.toggleFloatAnimations();
  },
  methods:{

  }
}
</script>